<template>
  <div id="account-expired" v-if="showAccountExpiredToast">
    <el-dialog
      class="akadm-dialog-modal renew-class-dialog"
      title="续费"
      @closeModal="closeModal"
      :visible.sync="renewModalVisible"
      :close-on-click-modal="false"
    >
      <renewClass
        :curClassid="curClassId"
        :singlePrice="singlePrice"
        :canClickSpoken="singlePrice.spokenSwitch"
        @paySuccecc="updateRenew"
        @onlyClose="closeModal"
        @closeModal="closeModal"
      ></renewClass>
    </el-dialog>
    <van-popup
      position="right"
      :style="{ height: '100%', width: '100%' }"
      v-model="popup_show"
    >
      <mobileRenewClass
        @paySuccecc="updateRenew"
        @onlyClose="closeModal"
        @closeModel="closeModal"
        :curClassId="curClassId"
        :singlePrice="singlePrice"
        :canClickSpoken="singlePrice.spokenSwitch"
      ></mobileRenewClass>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import renewClass from "@/page/teacher/personalCenter/part/renewClass.vue";
import mobileRenewClass from "@/page/teacher/personalCenter/mobile/part/renewClass";
import * as Api from "./indexApi";
import { Notification } from "element-ui";

export default {
  name: "accountExpiredToast",
  components: { renewClass, mobileRenewClass },
  data() {
    return {
      can_show_spoken: false, //是否开启口语
      can_click_spoken: false, //是否是英语学科
      popup_show: false, //手机jp
      instance: null, // 当前提示框
      instance1: null, // 提示框 当前班级状态为：正常；且未有学生支付
      userType: this.$cookies.get("user_type"),
      showAccountExpiredToast: true,
      renewModalVisible: false,
      curClassId: null,
      curClassStatus: null,
      curAccountId: null,
      classStatus: {
        is_valid_near_expired: 1, // 当前班级状态为：正常，当前日期距离有效日期的截止日期≤3天;且未有当前之后的有效日期（即未续过班）
        is_free_near_expired: 6, // 当前班级状态为：体验中，当前日期距离有效日期的截止日期≤3天;且未有当前之后的有效日期（即未续过班）
        disabled: 2, // 当前班级状态为：停用 ; 且未有当前之后的有效日期（即未续过班)
        disabled_already_renew: 3, // 当前班级状态为：停用；已有当前之后的有效日期（即已续过班）
        stu_disabled: 4, // 学生账号到期
        valid_no_stu_paid: 5, // 当前班级状态为：正常；且未有学生支付
      },
    };
  },
  watch: {
    $route(to, from) {
      let notShowRoute = ["jpLogin", "forget-password", "register", "ground"];
      if (notShowRoute.indexOf(this.$route.name) > -1) {
        this.instance && this.instance.close();
      }
    },
    jpAccountRenewInfo(data) {
      this.curClassStatus = null;
      if (!data || this.org_code() != "jp") {
        this.instance && this.instance.close();
        this.instance1 && this.instance1.close();
        this.curClassId = null;
        this.curAccountId = null;
        return;
      }
      // 教师
      if (this.$cookies.get("user_type") == 1) {
        // 首次进入和切换班级才显示
        if (
          this.curClassId == this.$cookies.get("jp_teacher_class_id") ||
          this.$route.name != "index"
        ) {
          return;
        }

        this.instance && this.instance.close();
        this.instance1 && this.instance1.close();

        this.curClassId = this.$cookies.get("jp_teacher_class_id");

        if (data.is_valid === true) {
          // 可用，最后一次续班过期时间小于3天
          if (!this.checkIsOver3Days()) {
            this.curClassStatus = this.classStatus.is_valid_near_expired;
          }
          // 当前班级状态为：非体验且未有学生支付
          if (!data.is_free && !data.has_paid_student) {
            setTimeout(() => {
              this.checkClassIsExpired1();
            }, 0);
          }
        }
        // 不可用
        if (data.is_valid === false) {
          if (this.jpAccountRenewInfo.jp_class_valid_dates.length == 0) {
            // 从未续班
            this.curClassStatus = this.classStatus.disabled;
          } else {
            // 已续班
            this.curClassStatus = this.classStatus.disabled_already_renew;
          }
        }
      } else {
        // 学生
        if (this.curAccountId == this.$cookies.get("jp_stu_account_id")) {
          return;
        }
        this.instance && this.instance.close();
        this.instance1 && this.instance1.close();
        this.curAccountId = this.$cookies.get("jp_stu_account_id");
        if (data.is_valid === false) {
          this.curClassStatus = this.classStatus.stu_disabled;
        }
      }
      this.checkClassIsExpired();
    },
  },
  computed: {
    singlePrice() {
      return this.$store.getters.getJpTeacherRenewPrice;
    },
    jpAccountRenewInfo() {
      return this.$store.getters.getJpAccountRenewInfo;
    },
  },
  methods: {
    checkClassStatus() {},
    checkClassIsExpired() {
      const h = this.$createElement;
      let text = "",
        text1 = "";
      let btnText = "";
      let first_start_time = this.getFirstStartTime();
      let last_end_time = this.getLastEndTime();
      let action = this.renewClassAction;

      console.log("开始时间：", this.format(first_start_time, "yyyy.MM.dd"));
      console.log("结束时间：", this.format(last_end_time, "yyyy.MM.dd"));

      if (!this.curClassStatus) {
        return;
      }

      if (this.curClassStatus == this.classStatus.is_valid_near_expired) {
        text = `该班级 ${this.jpAccountRenewInfo.name} 将于 ${this.format(
          last_end_time,
          "yyyy.MM.dd"
        )} 到期，老师和学生账号可以继续使用，但只能查看已产生数据和资源。老师可自行开班进行完整教学。学生按日计费，老师永久免费。`;
        btnText = "点击进入设置";
      }

      if (this.curClassStatus == this.classStatus.valid_no_stu_paid) {
        text = `该班级 ${this.jpAccountRenewInfo.name} 尚未有学生支付，部分功能不能使用，请联系学生及时支付去体验完整服务~`;
      }

      if (this.curClassStatus == this.classStatus.disabled) {
        text = `该班级 ${this.jpAccountRenewInfo.name} 已停用，老师和学生账号可以继续使用，但只能查看已产生数据和资源。老师可自行开班进行完整教学。学生按日计费，老师永久免费。`;
        btnText = "点击进入设置";
      }

      if (this.curClassStatus == this.classStatus.disabled_already_renew) {
        text = `该班级 ${
          this.jpAccountRenewInfo.name
        } 已到期，将按照续班设置于 ${this.format(
          first_start_time,
          "yyyy.MM.dd"
        )} 恢复正常使用。期间老师和学生账号可以继续使用，但只能查看已产生数据和资源。`;
      }

      if (this.curClassStatus == this.classStatus.stu_disabled) {
        text = `该账号已过期，仍可继续使用查看已留存数据和资源，但无法接收任何新资源。请按照老师设置的班级费用，`;
        btnText = "点击进入付费";
        text1 = `。或联系老师续费。`;
        action = this.gotoPersonalCenter;
      }

      this.instance = Notification({
        customClass: "jp-expired-toast",
        title: "提示",
        iconClass: "tips-icon",
        message: h("div", null, [
          h("span", null, text),
          h(
            "a",
            {
              on: {
                click: action,
              },
            },
            btnText
          ),
          h("span", null, text1),
        ]),
        duration: 0,
      });
    },
    checkClassIsExpired1() {
      const h = this.$createElement;
      let text = `该班级 ${this.jpAccountRenewInfo.name} 尚未有学生支付，部分功能不能使用，请联系学生及时支付去体验完整服务~`;
      this.instance1 = Notification({
        customClass: "jp-expired-toast",
        title: "提示",
        iconClass: "tips-icon",
        message: h("div", null, [h("span", null, text)]),
        duration: 0,
      });
    },
    getFirstStartTime() {
      if (JSON.stringify(this.jpAccountRenewInfo) == "{}") {
        return;
      }
      let startTimeArr = this.jpAccountRenewInfo.jp_class_valid_dates.map(
        (e) => e.start
      );
      return Math.min(...startTimeArr);
    },
    getLastEndTime() {
      if (JSON.stringify(this.jpAccountRenewInfo) == "{}") {
        return;
      }
      let endTimeArr = this.jpAccountRenewInfo.jp_class_valid_dates.map(
        (e) => e.end
      );
      return Math.max(...endTimeArr);
    },
    checkIsOver3Days() {
      if (this.jpAccountRenewInfo.jp_class_valid_dates.length > 0) {
        return (
          this.getLastEndTime() * 1000 - new Date().getTime() >
          3 * 24 * 60 * 60 * 1000
        );
      }
    },
    checkCurPeriodHasStuPay() {
      let curTime = new Date().getTime();
      if (this.jpAccountRenewInfo.jp_class_valid_dates.length > 0) {
        let curPeriod = this.jpAccountRenewInfo.jp_class_valid_dates.find(
          (e) =>
            e.start * 1000 <= curTime &&
            e.end * 1000 >= curTime &&
            e.has_paid_student == true
        );
        if (curPeriod) return true;
      }
      return false;
    },
    closeModal() {
      this.renewModalVisible = false;
      this.popup_show = false;
    },
    updateRenew() {
      this.renewModalVisible = false;
      this.popup_show = false;
      let data = {
        class_id: this.$cookies.get("jp_teacher_class_id"),
      };
      this.curClassId = null;
      this.instance && this.instance.close();
      this.$store.dispatch("CHECK_JP_RENEW_IFNO", data);
    },
    renewClassAction() {
      // this.renewModalVisible = true;
      if (!this.isPc()) {
        // sessionStorage.setItem('commingTtyp',2);
        this.popup_show = true;
        this.renewModalVisible = false;
      } else {
        this.renewModalVisible = true;
        this.popup_show = false;
      }
    },
    gotoPersonalCenter() {
      this.$router.push({
        path: "/student-personal-center",
        name: "student-personal-center",
        params: {
          sec_name: "orderDetails",
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
.jp-expired-toast {
  margin-top: 0.5rem;
  width: auto;
  max-width: 90%;
  padding: 0.2rem 0.26rem 0.2rem 0.14rem;
  user-select: none;

  .tips-icon {
    margin-top: 0.08rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url("~@/assets/images/icon_warning.svg") no-repeat center center;
    background-size: 0.3rem auto;
  }
  a {
    color: #fa6400;
    cursor: pointer;
  }
}
</style>
